import Date from "./Date";

const Dates = () => <Date />;

export default Dates;
